/* eslint-disable prettier/prettier */
import { Badge, IconButton } from '@material-ui/core'

import Tooltip from '@material-ui/core/Tooltip'
import InfoIcon from '@material-ui/icons/Info'
import Typography from '@material-ui/core/Typography'
import FileCopyIcon from '@material-ui/icons/FileCopy'
import MoreIcon from '@material-ui/icons/More'
import ChildFriendlyIcon from '@material-ui/icons/ChildFriendly'
import HouseIcon from '@material-ui/icons/House'

import ChatIcon from '@material-ui/icons/Chat'

import React, { useEffect, useState, useContext} from 'react'
import styles from './styles'

import Drawer from '@material-ui/core/Drawer'

import SideMenu from '../sideMenu'

import useSignal from '../../hooks/useSignal'
import { VideoCallContext, useVideoCall } from '../../../../hooks/videoCallContext'

export default function MoreOptionsButton({
  classes,
  participants,
  room,
  localParticipant,
  roomId,
  miniPlayer
}) {
  const { listOfMessages } = useSignal({ room, roomId })
  const titleToolTip = 'Chat'
  const localClasses = styles()
  const [state, setState] = React.useState(false)
  const { roomState, setRoomState } = useVideoCall(roomId)
  const {getRoomState } = useContext(VideoCallContext)


  // Efeito para detectar novas mensagens
useEffect(() => {
  const contextMessages = roomState?.listOfMessages || []
  if (!state && listOfMessages.length > contextMessages.length) {
    const newMessages = listOfMessages.slice(contextMessages.length)
    setRoomState({
      listOfMessages: [...contextMessages, ...newMessages],
      unreadCount: (roomState?.unreadCount || 0) + newMessages.length,
      prevMessageCount: listOfMessages.length
    })
  }
}, [listOfMessages.length, state])

  // Reseta contagem ao abrir o chat
  useEffect(() => {
    if (state) {
      setRoomState({ unreadCount: 0 })
    }
  }, [state])

  
  const toggleDrawer = () => event => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return
    }
    setState(!state)
  }

  return (
    <div>
      {!miniPlayer && (
      <Tooltip title={titleToolTip} aria-label="add">
        <IconButton
          onClick={toggleDrawer()}
          edge="start"
          color="inherit"
          aria-label="mic"
          className={localClasses.infoButton}
          
        >
          <Badge 
            badgeContent={roomState?.unreadCount || 0} 
            color="secondary"
            invisible={roomState?.unreadCount === 0}
          >
            <ChatIcon fontSize="inherit" />
          </Badge>
        </IconButton>
      </Tooltip>
      )}
      <Drawer
        open={state}
        onClose={toggleDrawer()}
        classes={{ paper: localClasses.paper }}
      >
        <SideMenu
          room={room}
          participants={participants}
          localParticipant={localParticipant}
          listOfMessages={listOfMessages}
          roomId={roomId}
        >
        </SideMenu>
      </Drawer>
    </div>
  )
}